export const MEGABYTE: number = 1024 * 1024;
